global.$ = global.jQuery = $;
const Rellax = require('rellax');

jQuery(function($){

});

var Init = function(){
  let $window = $(window);
  let $header = $("#masthead");
  let _scrollToTarget = function(event){
    let _navHeight = $header.outerHeight();
    let __$target = $(event.currentTarget);
    let __targetHash = __$target.attr("href");

    if(__targetHash === "" || __targetHash.indexOf("#") !== 0){
      return false;
    }
    let __targetOffsetTop = $(__targetHash).offset().top - _navHeight;
    $("html, body").stop().animate({scrollTop: __targetOffsetTop}, 400);
    return false;
  };
  $(".anchor").on("click", _scrollToTarget);

  var _hash = location.hash.replace('_anchor','');
  var $scrollTarget = $(_hash);
  if($scrollTarget.length > 0){
    $("html, body").stop().delay(100).animate({scrollTop: $scrollTarget.offset().top - $header.outerHeight()}, 400);
  }

  let allAppearFrag = false;
  let setAnimation = function(){
    let $section = $(".animate-section");
    let sectionLen = $section.length;
    let timing;
    if($window.width() < 768){
      timing = $window.height() - $window.height() / 3;
    }else{
      timing = $window.height() - $window.height() / 3;
    }
    for(let i = 0; i < sectionLen; i++){
      let $target = $($section[i]);

      if($target.offset().top > $window.scrollTop() && $window.scrollTop() + timing > $target.offset().top){
        let $wait = $target.find(".wait");
        $wait.each(function(n){
          $($wait[n]).delay(n * 150).queue(function(){
            $(this).removeClass("wait").addClass('animation');
          });
        });
        if($(".wait").length === 0){
          allAppearFrag = true;
        }
      }
    }
  };

  let Resizer = function(){
  };
  let Scroller = function(){
    setAnimation();
  };


  $window.on("resize", Resizer);
  Resizer();
  $window.on("scroll", Scroller);
  Scroller();

  var rellax = new Rellax('.rellax', {});


  var archivePage = document.querySelector(".archive-page");
  if(archivePage){
    var archiveTab = $(".archive--tab");
    var archiveWrap = $(".archive-wrap");
    var yearTab = $(".year--tab");
    var yearContent = $(".year-content");

    var tabFunc = function(event){
      var $this = $(event.currentTarget);
      if($this.hasClass("current")) return;

      var dataWrap = $this.data("wrap");
      archiveWrap.removeClass("current");
      archiveWrap.each(function(){
        var $wrap = $(this);
        if($wrap.data("wrap") === dataWrap){
          $wrap.addClass("current");
        }
      });

      archiveTab.removeClass("current");
      $this.addClass("current");
    };

    var yearFunc = function(event){
      var $this = $(event.currentTarget);
      if($this.hasClass("current")){
        yearContent.css({display: ""});
        yearTab.removeClass("current");
      }else{
        yearContent.css({display: "none"});
        var dataYear = $this.data("year");
        yearContent.each(function(){
          var $year = $(this);
          if($year.data("year") === dataYear){
            $year.css({display: ""});
          }
        });

        yearTab.removeClass("current");
        $this.addClass("current");
      }
    };


    archiveTab.on("click", tabFunc);
    yearTab.on("click", yearFunc);
  }
};

window.addEventListener("load", Init);